var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartup6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 134.106,
    height: 134.106,
    rx: 67.0529,
    fill: "#575E76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6822 39.276C81.1 38.6449 85.0526 42.0729 85.0526 46.5356V50.2063C88.2244 51.883 90.3859 55.2155 90.3859 59.0529V85.7196C90.3859 91.2424 85.9088 95.7196 80.3859 95.7196H53.7192C48.1964 95.7196 43.7192 91.2424 43.7192 85.7196V48.3863C43.7192 48.3615 43.7197 48.3368 43.7206 48.3122C43.7197 48.2738 43.7192 48.2353 43.7192 48.1967C43.7192 45.7801 45.4963 43.7311 47.8886 43.3894L76.6822 39.276ZM47.7192 53.0529V85.7196C47.7192 89.0333 50.4055 91.7196 53.7192 91.7196H80.3859C83.6996 91.7196 86.3859 89.0333 86.3859 85.7196V59.0529C86.3859 55.7392 83.6996 53.0529 80.3859 53.0529H47.7192ZM48.5754 49.0529H81.0526V46.5356C81.0526 44.5071 79.2559 42.9489 77.2478 43.2358L48.4543 47.3492C48.0325 47.4094 47.7192 47.7707 47.7192 48.1967C47.7192 48.6696 48.1026 49.0529 48.5754 49.0529ZM54.3859 67.0529C54.3859 65.9484 55.2813 65.0529 56.3859 65.0529H77.7192C78.8238 65.0529 79.7192 65.9484 79.7192 67.0529C79.7192 68.1575 78.8238 69.0529 77.7192 69.0529H56.3859C55.2813 69.0529 54.3859 68.1575 54.3859 67.0529ZM54.3859 76.3863C54.3859 75.2817 55.2813 74.3863 56.3859 74.3863H71.0526C72.1571 74.3863 73.0526 75.2817 73.0526 76.3863C73.0526 77.4908 72.1571 78.3863 71.0526 78.3863H56.3859C55.2813 78.3863 54.3859 77.4908 54.3859 76.3863Z",
    fill: "#1C274D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup6);
export default __webpack_public_path__ + "static/media/startup-6.7d85c19b7062194e2bde6bb45bea2ccf.svg";
export { ForwardRef as ReactComponent };